import React from 'react'
import classNames from 'classnames'
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineBulb } from 'react-icons/ai'
import i18n from '../../../../lib/i18n'
import { ANSWER_COMPONENTS, TYPE_HINTS } from '../answers'
import styles from './QuestionCard.module.scss'

const isEmptyHtml = (html) => !String(html || '').replace(/<[^>]*>|&nbsp;|\s/g, '')

function QuestionCard({ question, number, total, draft, order, onChange, onSubmit, result }) {
  const Answer = ANSWER_COMPONENTS[question.question_type]
  const checked = result !== undefined

  return (
    <article className={styles.QuestionCard}>
      <header className={styles.meta}>
        {total > 1 && <span className={styles.counter}>{i18n('qv_question')} {number} / {total}</span>}
        <span className={styles.hint}>{i18n(TYPE_HINTS[question.question_type])}</span>
      </header>

      <div className={styles.question} dangerouslySetInnerHTML={{ __html: question.question }} />

      {Answer && (
        <Answer
          question={question}
          draft={draft}
          order={order}
          checked={checked}
          onChange={onChange}
          onSubmit={onSubmit}
        />
      )}

      {checked && (
        <div className={styles.feedback} aria-live="polite">
          <div className={classNames(styles.result, result ? styles.ok : styles.bad)}>
            {result ? <AiOutlineCheckCircle size={24} /> : <AiOutlineCloseCircle size={24} />}
            <div>
              <div className={styles.resultTitle}>{result ? i18n('qv_result_ok') : i18n('qv_result_bad')}</div>
              <div className={styles.resultText}>{result ? i18n('qv_result_ok_text') : i18n('qv_result_bad_text')}</div>
            </div>
          </div>
          {!isEmptyHtml(question.description) && (
            <div className={styles.explanation}>
              <div className={styles.explanationTitle}><AiOutlineBulb size={16} />{i18n('qv_explanation')}</div>
              <div className={styles.explanationBody} dangerouslySetInnerHTML={{ __html: question.description }} />
            </div>
          )}
        </div>
      )}
    </article>
  )
}

export default QuestionCard
